export default "__VITE_ASSET__766a3a60__"